/**
 * Indicates the current state of the fetching of media over the network.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/networkState
 */
export var MediaNetworkState;
(function (MediaNetworkState) {
    /**
     * There is no data yet. Also, `readyState` is `HaveNothing`.
     */
    MediaNetworkState[MediaNetworkState["Empty"] = 0] = "Empty";
    /**
     * Provider is active and has selected a resource, but is not using the network.
     */
    MediaNetworkState[MediaNetworkState["Idle"] = 1] = "Idle";
    /**
     * The browser is downloading data.
     */
    MediaNetworkState[MediaNetworkState["Loading"] = 2] = "Loading";
    /**
     * No source has been found.
     */
    MediaNetworkState[MediaNetworkState["NoSource"] = 3] = "NoSource";
})(MediaNetworkState || (MediaNetworkState = {}));
